import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-10269ed6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "therapy-items-bar__item-text"
}

import 'swiper/css';
import { nextTick, reactive, ref, watch } from 'vue';
import { TherapyBarItem } from '@/types/ui';
import { useInternalization } from '@/composables/useInternalization';
import { TherapyVideoType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TherapyVideoItem',
  props: {
    item: {},
    narrow: { type: Boolean },
    square: { type: Boolean },
    titleOnImg: { type: Boolean },
    tabs: {},
    hideTag: { type: Boolean }
  },
  emits: ['item:click'],
  setup(__props: any, { emit: __emit }) {

const state = reactive({
  isImageLoaded: false,
});
const imageRef = ref<HTMLImageElement | null>(null);

const props = __props;
const emit = __emit;

const { locale } = useInternalization();

watch(
  () => props.item,
  () => {
    nextTick(() => checkIfImagesLoaded());
  },
  { immediate: true }
);

const handleItemClick = (item: TherapyBarItem) => {
  emit('item:click', item);
};

const checkIfImagesLoaded = () => {
  if (!imageRef.value) {
    return;
  }

  state.isImageLoaded = !!imageRef.value?.complete;
};
const getTitle = (item: TherapyBarItem) => {
  if (!item.translations) {
    return item.title;
  }

  return item.translations[locale.value]?.title || item.title;
};
const getText = (item: TherapyBarItem) => {
  if (!item.translations) {
    return item.text;
  }

  return item.translations[locale.value]?.text || item.text;
};

const getTypeTitle = (item: TherapyBarItem) => {
  if (!item.translations) {
    return item.type;
  }

  return (
    props.tabs?.find((t) => t.value.toLowerCase() === item.type?.toLowerCase())
      ?.title || item.type?.toLowerCase()
  );
};

const getItemTagColor = (item: TherapyBarItem) => {
  if (item.type) {
    const colors: Record<TherapyVideoType, string> = {
      sound: '#5FC4FD',
      music: '#C467F0',
      asmr: '#FF87B9',
    };
    return colors[item.type] || colors.sound;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'therapy-items-bar__item',
      { 'therapy-items-bar__item--narrow': props.narrow },
      { 'therapy-items-bar__item--square': props.square },
    ]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (handleItemClick(_ctx.item)))
  }, [
    (_ctx.item.type && !_ctx.hideTag)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "therapy-items-bar__item-tag",
          style: _normalizeStyle({ 'background-color': getItemTagColor(_ctx.item) })
        }, _toDisplayString(getTypeTitle(_ctx.item)), 5))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("img", {
      class: "therapy-items-bar__item-image",
      ref_key: "imageRef",
      ref: imageRef,
      src: _ctx.item.img,
      alt: "",
      onLoad: _cache[0] || (_cache[0] = ($event: any) => (state.isImageLoaded = true)),
      onError: _cache[1] || (_cache[1] = ($event: any) => (state.isImageLoaded = false))
    }, null, 40, _hoisted_1), [
      [_vShow, state.isImageLoaded]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "therapy-items-bar__item-image therapy-items-bar__item-image--placeholder",
      style: _normalizeStyle({ 'background-color': _ctx.item.background })
    }, null, 4), [
      [_vShow, !state.isImageLoaded]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
        'therapy-items-bar__item-title',
        {
          'therapy-items-bar__item-title--on-img': props.titleOnImg,
        },
      ])
    }, _toDisplayString(getTitle(_ctx.item)), 3),
    (_ctx.item.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(getText(_ctx.item)), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})